import { useState } from 'react'

/**
 * Getting-started checklist (v0.14.0, research-recommended tour successor).
 * Computed from real state — no server round-trips beyond what Dashboard already
 * loads. Auto-hides when everything is done; dismissible any time.
 */
export default function GettingStarted({ items }: {
  items: { label: string; done: boolean; hint: string; onClick?: () => void }[]
}) {
  const [hidden, setHidden] = useState(() => localStorage.getItem('fa_checklist_hidden') === '1')
  const doneCount = items.filter(i => i.done).length
  if (hidden || doneCount === items.length) return null

  return (
    <div className="relative card-glass p-5 mb-6 border-teal-500/20 fade-up">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-display text-lg font-semibold text-slate-100">🚀 Getting started — {doneCount}/{items.length}</h2>
        <button onClick={() => { localStorage.setItem('fa_checklist_hidden', '1'); setHidden(true) }}
          className="text-[11px] text-slate-500 hover:text-slate-300">dismiss</button>
      </div>
      <div className="h-1 rounded-full bg-white/[0.07] overflow-hidden mb-3">
        <div className="h-full bg-gradient-to-r from-teal-500/70 to-gold-500/70 transition-all" style={{ width: `${(doneCount / items.length) * 100}%` }} />
      </div>
      <div className="grid sm:grid-cols-2 gap-1.5">
        {items.map(it => (
          <button key={it.label} onClick={it.done ? undefined : it.onClick} disabled={it.done}
            className={`flex items-center gap-2.5 px-3 py-2 rounded-xl border text-start text-sm transition-colors ${
              it.done ? 'border-teal-500/25 bg-teal-500/[0.06] text-slate-500' : 'border-white/[0.08] bg-white/[0.03] text-slate-200 hover:border-gold-500/40 cursor-pointer'}`}>
            <span className={`w-5 h-5 rounded-full flex items-center justify-center text-[11px] flex-shrink-0 border ${
              it.done ? 'bg-teal-500/20 border-teal-500/40 text-teal-300' : 'border-white/20 text-slate-600'}`}>{it.done ? '✓' : ''}</span>
            <span className="min-w-0">
              <span className={`block truncate ${it.done ? 'line-through' : ''}`}>{it.label}</span>
              {!it.done && <span className="block text-[10px] text-slate-500 truncate">{it.hint}</span>}
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}
